/**
 * Created by Bob.Bao on 2017/12/27.
 */

export default {
    baseUrl: window.__baseUrl__ || [
        'http://172.18.10.155:8080/',
        'http://172.18.10.221:8080/',
        'http://172.18.10.236:8080/',
        'http://58.210.98.35:9007/',
        'http://cgtest.dahuahome.com:8081/',
        'http://localhost:8080/',
        'http://139.217.207.66/'
    ][6], // 0e:qa 1:jf 2:wod 3:qa_outside_address ,4:UAT 5: wood.xu
    buildEnv: window.__buildEnv__ || 'qa',
    email: {tousu: 'tousu@dahuahome.com', jubao: 'jubao@dahuahome.com'},
    alertTitle: '',
    acceptFileTypes: ['gif', 'jpg', 'jpeg', 'bmp', 'gif', 'tif', 'dwt', 'dwg', 'dws', 'dxf', 'png', 'txt', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'vsd', 'mpp', 'pdf', 'rar', 'zip', '7z'],
    allowUpload (name) {
        if (~name.indexOf('.')) {
            const suffix = name.substr(name.lastIndexOf('.') + 1).toLowerCase()
            return this.acceptFileTypes.indexOf(suffix) > -1
        }
        return false
    },
    isPublicRoute (route) {
        return !!~['Index', 'Login', 'Forget', 'Register', 'RegisterNext', 'Help', 'Download', 'WinList', 'InviteInfo', 'InviteList', 'WinDetail', 'CarouseDetail', 'not-found', 'NoticeList', 'NoticeInfo', 'performanceSupplierNoticeInfo', 'peSupplierList', 'sysYearList'].indexOf(route)
    },
    store: {
        set (key, value, time) {

        },
        get (key) {
            window.sessionStorage.getItem(key)
        },
        clear (key) {
            window.sessionStorage.removeItem(key)
        }
    },
    toTop () {
        var anc = window.toTopSet || window.toTopAnchor || {}
        var anchor = anc.offsetTop || 0
        var gotoTop = function () {
            var currentPosition = document.documentElement.scrollTop || document.body.scrollTop
            currentPosition -= 10
            if (currentPosition > anchor) {
                window.scrollTo(0, currentPosition)
            } else {
                window.scrollTo(0, anchor)
                clearInterval(timer)
                timer = null
            }
        }
        var timer = setInterval(gotoTop, 4)
    },
    hasIdCardNullFlag(vue) {
        vue.$http.post('/rest/api/dspUserApi/idCardNullCheck', vue.$root.stockId).then((res) => {
            if (!res.data.result) {
               if(res.data.message.indexOf('工程负责人')!=-1){
                   vue.$alert(res.data.message, '提示：', {
                       showClose: true
                   })
               }else{
                   vue.$alert(res.data.message, '提示：', {
                       confirmButtonText: '前往',
                       showClose: false,
                       callback: action => {
                           vue.$router.push('/supplier')
                       }
                   })
               }
            }
        })
    }
}

// prototype
// 拼接 JSON 字段
Array.prototype.joinAt = function (key, symbol, backup) {
    var smb = symbol || ';'
    if (!key) {
        return ''
    }
    var res = ''
    this.forEach(function (data, index) {
        res += (index != 0 ? smb : '') + (data[key] || data[backup])
    })
    return res
}

// 通过键值 获取 JSON 相应字段
Array.prototype.matchAt = function (key, val, need) {
    var res = ''
    this.forEach(function (data, index) {
        if (data[key] == val) {
            res = need ? data[need] : data
        }
    })
    return res
}

Date.prototype.getDatetime = function () {
    var Y = this.getFullYear(),
        M = this.getMonth() + 1,
        D = this.getDate(),
        h = this.getHours(),
        m = this.getMinutes(),
        s = this.getSeconds()
    return Y + '-' + (M > 9 ? M : '0' + M) + '-' + (D > 9 ? D : '0' + D) + ' ' + (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s)
}



// WEBPACK FOOTER //
// ./src/util/index.js